import authRequest from '../utils/authRequest'

export const deviceCertification = (data) =>
  authRequest.post('/Auth/DeviceCertification', data)
export const checkBinding = (data) =>
  authRequest.get(`Auth/CheckBinding?c=${data.c}&u=${data.u}`)
